import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { DROP_DATE } from "../i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TARGET = new Date(DROP_DATE).getTime();
const PORT_TARGET = new Date("2026-09-14T22:00:00+02:00").getTime();

const diff = () => {
  const ms = Math.max(0, TARGET - Date.now());
  return {
    d: Math.floor(ms / 86400000),
    h: Math.floor((ms / 3600000) % 24),
    m: Math.floor((ms / 60000) % 60),
    s: Math.floor((ms / 1000) % 60),
  };
};

const portDiff = () => {
  const ms = Math.max(0, PORT_TARGET - Date.now());
  return {
    h: Math.floor(ms / 3600000),
    m: Math.floor((ms / 60000) % 60),
    s: Math.floor((ms / 1000) % 60),
  };
};

export const Countdown = ({ t }) => {
  const [time, setTime] = useState(diff());
  const [port, setPort] = useState(portDiff());
  const [waiting, setWaiting] = useState(null);

  useEffect(() => {
    const id = setInterval(() => {
      setTime(diff());
      setPort(portDiff());
    }, 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const load = () =>
      axios.get(`${API}/drop-signup/count`).then((r) => setWaiting(r.data.count)).catch(() => {});
    load();
    const id = setInterval(load, 15000);
    return () => clearInterval(id);
  }, []);

  const cells = [
    { v: time.d, l: t.countdown.days, bg: "bg-[#f4f1ea]" },
    { v: time.h, l: t.countdown.hours, bg: "bg-[#e5b83b]" },
    { v: time.m, l: t.countdown.minutes, bg: "bg-[#f4f1ea]" },
    { v: time.s, l: t.countdown.seconds, bg: "bg-[#d96b43]" },
  ];

  return (
    <section data-testid="countdown-section" className="halftone-light bg-[#0a0a0a] py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.p
          className="mb-10 text-center font-mono2 text-[11px] font-bold tracking-[0.4em] text-[#e5b83b]"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          {t.countdown.label}
        </motion.p>
        <div className="grid grid-cols-4 gap-4 sm:gap-7">
          {cells.map((c, i) => (
            <motion.div
              key={c.l}
              data-testid={`countdown-cell-${i}`}
              className={`toon-card ${c.bg} px-2 py-8 text-center sm:py-12 ${i % 2 ? "rotate-[1.2deg]" : "-rotate-[1.2deg]"}`}
              initial={{ opacity: 0, y: 50, rotate: i % 2 ? 6 : -6 }}
              whileInView={{ opacity: 1, y: 0, rotate: i % 2 ? 1.2 : -1.2 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.65, ease: [0.34, 1.56, 0.64, 1] }}
            >
              <div className="font-display text-4xl font-black tabular-nums text-[#0a0a0a] sm:text-6xl lg:text-7xl">
                {String(c.v).padStart(2, "0")}
              </div>
              <div className="mt-3 font-script text-sm text-[#0a0a0a]/80 sm:text-lg">{c.l}</div>
            </motion.div>
          ))}
        </div>
        {waiting !== null && (
          <motion.div
            className="mt-10 flex justify-center"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ ease: [0.34, 1.56, 0.64, 1] }}
          >
            <span data-testid="signup-count" className="toon-chip inline-flex items-center gap-3 bg-[#f4f1ea] px-6 py-3 font-script text-lg text-[#0a0a0a] sm:text-xl">
              <span className="h-2.5 w-2.5 animate-pulse rounded-full bg-[#d96b43]" />
              {waiting} {t.countdown.waiting}
            </span>
          </motion.div>
        )}
        <motion.div
          className="mt-5 flex justify-center"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
        >
          <span data-testid="port-countdown" className="toon-chip inline-flex rotate-[1deg] items-center gap-3 bg-[#e5b83b] px-5 py-2.5 font-mono2 text-[11px] font-bold tracking-[0.2em] text-[#0a0a0a] sm:text-xs">
            {t.countdown.port}
            <span className="font-display text-base tabular-nums sm:text-lg">
              {String(port.h).padStart(2, "0")}:{String(port.m).padStart(2, "0")}:{String(port.s).padStart(2, "0")}
            </span>
          </span>
        </motion.div>
      </div>
    </section>
  );
};
